import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import findResult, { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import CloseButton from '@/components/buttons/CloseButton';
import DownloadButton from '@/components/buttons/DownloadButton';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import DictionaryReportPanel from './DictionaryReportPanel';
import { dictionaryReportDownload, hideDictionaryReport } from '../actions';

const DictionaryReportDialog = ({
  category,
  code,
  hide,
  theme,
  readStatus,
  reportId,
  reportType,
  startDownload,
}) => {
  const intl = useIntl();
  return (
    <DialogWrapper
      className="aridhia-dictionary-report-dialog smallwizard"
      onClose={() => hide(category, code, reportType, reportId)}
      size="large"
      theme={theme}
      {...(reportType && {
        title: intl.formatMessage({
          id: `dataset.data.dictionary.${reportType}.results`,
        }),
      })}
    >
      {reportId && (
        <Modal.Content scrolling>
          <DictionaryReportPanel category={category} code={code} reportId={reportId} reportType={reportType} />
        </Modal.Content>
      )}
      <Modal.Actions>
        <CloseButton
          onClick={() => hide(category, code, reportType, reportId)}
          disabled={readStatus === states.PENDING}
          closeMessageId="actions.close"
        />
        <DownloadButton
          onClick={() => startDownload(
            category,
            code,
            reportType,
            { id: reportId, name: reportId },
            true,
          )}
          disabled={readStatus !== states.SUCCESS}
          loading={readStatus === states.PENDING}
          positive
        />
      </Modal.Actions>
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  datasetReports: {
    dictionaryReportDialog: {
      category,
      code,
      name,
      reportId,
      reportType,
    },
    dictionaryReports,
  },
}) => {
  const item = findResult(dictionaryReports, category, code);
  const reportList = item ? item[reportType] : null;
  const report = reportList ? findMatch(reportList.items, reportId, 'reportId') : null;

  return {
    category,
    code,
    name,
    readStatus: report?.readStatus,
    reportId,
    reportType,
  };
};

const mapDispatchToProps = {
  hide: hideDictionaryReport,
  startDownload: dictionaryReportDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryReportDialog);
